import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';
import { routerStore, Link } from 'core/routing';

import Button from 'components/Button';

import { Overlay } from 'apps/modals/styles';
import {
  SideWrapper,
  CloseSide,
  SideContent,
} from 'apps/forum/views/side.styles';

@withNamespaces()
export class SideView extends React.Component {
  clickedOutside = e => {
    if (e.target !== this.overlay) return;
    this.resetParams();
  };

  resetParams = () => {
    const { params } = routerStore.route;
    // FIXME - Add function to core/routing to iterate over route.meta and unset every 'query' param
    delete params.thread;
    routerStore.navigate(routerStore.route.name, params);
  };

  componentDidMount() {
    window.addEventListener('click', this.clickedOutside);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.clickedOutside);
  }

  render() {
    const app =
      window.document.getElementById('app') ||
      window.document.querySelector('body');
    const initiative = routerStore.params.get('initiative');
    const threadId = routerStore.params.get('thread');
    const expandParams = Object.assign(
      {},
      {
        initiative,
        threadId,
      },
    );

    return ReactDOM.createPortal(
      <Overlay
        noScroll
        visible
        ref={ref => {
          this.overlay = ref;
        }}
      >
        <SideWrapper>
          <CloseSide>
            <Link name='initiative.forum.thread' params={expandParams}>
              <Button
                text={<Trans>Expand</Trans>}
                appearance='plain'
                icon='launch'
                size='small'
                outline
              />
            </Link>
          </CloseSide>
          <SideContent>{this.props.children}</SideContent>
        </SideWrapper>
      </Overlay>,
      app,
    );
  }
}

SideView.propTypes = {
  threadId: PropTypes.object,
  children: PropTypes.array,
};
